import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { StatusbarComponent } from '../../menu/statusbar/statusbar.component';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { ConfigService } from '../../../../services/config.service';
import { TranslationService } from '../../../../services/translation.service';
import { Helper, MenuNode, BaseSensor } from '../../../../classes';
import { ValueChangedConfirmation } from '../../../../classes/ValueChangedConfirmation';
@Component({
	selector: 'screen-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
	@Input('debug') debug: boolean = false;
	_unit: string = "AICI_UNIT_CELSIUS";
	_value: string = "22.0";
	dashIcon: string = "";
	get unit() {
		if (this.noHeatingDemand()) {
			return '';
		}
		if (this.sensor) {
			return this.sensor.getUnit();
		}
		return this._unit;
	}
	set unit(value: string) {
		this._unit = value;
	}
	constructor(
		private menuService: MenuService,
		private ioService: DataIoService,
		private config: ConfigService,
		private translator: TranslationService
	) {
	}
	sensor: BaseSensor;
	eventSubscription: any;

	mode = "default";

	getMode(): string {
		let di = this.ioService.deviceInfo();
		let remote_controlled = this.ioService.getDeviceInfo().getScale('d340').getCurrentElement() == 'AICI_YES_NORMAL';
		if (remote_controlled) {
			return 'remote-controlled';
		}
		for (let hc of di.getHeatingCircuits()) {
			if (hc.getScale('estrichtTrocknungsTag').getCurrentValue() > 0) {
				return 'estrichttrocknung';
			}
		}


		let defaultZoneId = this.ioService.deviceInfo().getDefaultZoneId();
		let defaultZone = this.ioService.deviceInfo().getZoneById(defaultZoneId);
		if (defaultZone.isAbsentAt(this.ioService.getCurrentTime())) {
			return 'absent';
		}
		if (defaultZone.getRawValue('quickset-temperature-enabled') == 'on') {
			return 'quickset-temperature';
		}

		this.menuService.resetMenuPositions();
		if (this.ioService.deviceInfo().isInBlockingMode()) {
			let states = this.ioService.deviceInfo().getBlockingStates();

			if (states.length > 0) {
				this.mode = states[0];
				return this.mode;
			}
		}
		if (this.ioService.deviceInfo().getRawValue('ai_mode') == 'heating') {
			return 'heating';
		}
		if (this.ioService.deviceInfo().getRawValue('ai_mode') == 'dhw') {
			return 'dhw';
		}

		if (this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode') == "ENUM_HEATING_MODE_OFF") {
			return 'heating_off';
		}

		return 'default';

	}
	disableSlider() {
		console.log("disabling slider.");
		this.menuService.disableButton('up');
		this.menuService.disableButton('down');
		this.menuService.disableButton('slider');
	}
	text: Array<string>;
	ngOnInit() {
		console.log("Dashboard initializing with " + this.getMode());
		if (this.eventSubscription) {
			this.eventSubscription.unsubscribe();
		}
		/*
		if(this.ioService.getConfiguration().simulatorConfig.hasControl()){
			this.disableSlider();
		}*/
		this.menuService.resetMenuPositions();
		switch (this.getMode()) {
			case 'cylinder_boost': {
				this.text = new Array<string>();
				for (let snip of ['', 'DELIGHT_HOTWATER_BOOST_DASHBOARD_LINE', 'DELIGHT_SPECIAL_FUNCTION_DASHBOARD_CANCEL']) {
					this.text.push(this.translator.tr(snip));
				}
				this.disableSlider();
				this.dashIcon = "iconDomesticWater";
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				break;
			}
			case 'heating': {
				this.dashIcon = null;
				this.mode = 'heating';
				this.text = new Array<string>();
				let s = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('room_temperature_nominal_quick');
				let dis = this.ioService.deviceInfo().getRawValue('ai_mode_heating') == 'OFF' || s.getCurrentValue() <= 4.5;
				if (!dis) {

					this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('room_temperature_nominal_quick');
					this.text.push(this.translator.tr('DELIGHT_DASHBOARD_DESIRED_HOTWATER_STATUS'));
					if (this.ioService.getConfiguration().simulatorConfig.hasSensoDIRECT()) {
						this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('room_temperature_nominal_quick');
						this.text = [this.translator.tr('DELIGHT_DASHBOARD_DESIRED_HEATING_TEMPERATURE')];
					}

				} else {
					this.sensor = null;
					this.dashIcon = 'iconHeatingDis';
					this.text.push(this.translator.tr('DELIGHT_DASHBOARD_DESIRED_HEATING_STATUS'));
					if (this.ioService.getConfiguration().simulatorConfig.hasSensoDIRECT()) {
						this.text = [
							this.translator.tr('DELIGHT_STATUS_ID_000')
						];
					}
				}/*
				if(this.ioService.getConfiguration().simulatorConfig.hasControl() && !dis){
					this.dashIcon = 'iconHeating';
					this.sensor = undefined;
					this.text = [this.translator.tr('DELIGHT_DASHBOARD_DESIRED_HEATING_STATUS')];
				}
				if(!this.ioService.getConfiguration().simulatorConfig.hasSensoDIRECT()){
					let secondLine=this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufisttemp').toString();
					secondLine += " "+this.translator.tr('DELIGHT_DASHBOARD_CURRENT_HEATING_TEMPERATURE');
					this.text.push(secondLine);
				}
				*/
				if (this.sensor) {
					this._unit = this.sensor.getUnit();
					this._value = "" + this.sensor.getCurrentValue();
				}
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				return;
			}
			case 'dhw': {
				this.dashIcon = null;
				this.mode = 'dhw';
				this.text = new Array<string>();
				//this.sensor = this.ioService.deviceInfo().getScale('__d006');
				this.sensor = this.ioService.deviceInfo().getDefaultZone()?.getSensor('temperature', 'water_nominal');
				let s = this.sensor;
				let dis = (s.getCurrentValue() <= 34);
				if (!dis) {

					this.text.push(this.translator.tr('DELIGHT_DASHBOARD_DESIRED_HOTWATER_TEMPERATURE'));
					this._unit = this.sensor.getUnit();
					this._value = "" + this.sensor.toString({ include_unit: false });

				} else {
					this.text.push(this.translator.tr('DELIGHT_DASHBOARD_DESIRED_HOTWATER_STATUS'));
					this.dashIcon = 'iconDomesticHotWaterDis';
				}
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				return;
			}
			case 'ventilation_boost': {
				this.text = new Array<string>();
				for (let snip of ['HOME_VENTILATION_BOOST_SUBLINE_1', 'HOME_VENTILATION_BOOST_SUBLINE_2', 'HOME_VENTILATION_BOOST_SUBLINE_3']) {
					this.text.push(this.translator.tr(snip));
				}
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				this.disableSlider();
				this.dashIcon = "iconVentilationBoost";
				return;
			}
			case 'continuous_cooling': {
				this.text = new Array<string>();
				for (let snip of ['DELIGHT_COOLING_ACTIVE_DASHBOARD_LINE', '', 'DELIGHT_SPECIAL_FUNCTION_DASHBOARD_CANCEL']) {
					this.text.push(this.translator.tr(snip));
				}
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				this.disableSlider();
				this.dashIcon = "iconCooling";
				return;
			}
			case 'remote-controlled': {
				this.mode = 'remote-controlled';
				this.text = ['DELIGHT_DASHBOARD_HEATING_STATUS_DESCRIPTION', 'DELIGHT_SYSTEM_CONFIG_HEATING_MENU_ENTRY_CURRENT_FLOW'].map((s: string) => this.translator.tr(s));
				this.text[1] += ' ' + this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').toString();
				this.disableSlider();
				this.dashIcon = 'iconHeating';

				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				return;
			}
			case 'system_off': {
				this.text = new Array<string>();
				this.menuService.disableButton('question');
				this.menuService.disableButton('menu');
				for (let snip of ['DELIGHT_TOAST_SYSTEM_OFF', 'HOME_SYSTEMOFF_SUBLINE_2', 'HOME_SYSTEMOFF_SUBLINE_3']) {
					this.text.push(this.translator.tr(snip));
				}
				this.disableSlider();
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				this.dashIcon = "iconOff2";
				return;
			}
			case 'estrichttrocknung': {
				this.mode = 'estrichttrocknung';
				let di = this.ioService.deviceInfo();
				for (let hc of di.getHeatingCircuits()) {
					if (hc.getScale('estrichtTrocknungsTag').getCurrentValue() > 0) {
						let tag = hc.getScale('estrichtTrocknungsTag').getCurrentValue();
						this.sensor = di.getScale('estrichttrocknung-tag-' + tag);
						this.text = new Array<string>();
						this.text.push('Trocknungstemperatur');
						this.text.push('Aktueller Tag: ' + tag);
						this.text.push('{{iconBack}} Abbrechen');
					}
				}
				this.disableSlider();
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				return;
			}

			case 'quickset-temperature': {
				this.debugOut("configuring for quickset-temperature");
				this.mode = 'quickset-temperature';
				let zone = this.ioService.deviceInfo().getDefaultZone();
				this.text = new Array<string>();
				this.text.push(this.translator.tr('DELIGHT_QUICK_VETO_SETPOINT_DESIRED_TEMP'));
				let endDate = zone.getDate('quickset-end-date');
				let endDateString = Helper.formatTime(endDate);
				this.disableSlider();
				let secondLine = (this.translator.tr('HOME_QUICK_VETO_SUBLINE_1')).replace("<joker>", endDateString);
				this.text.push(secondLine);
				this.text.push(this.translator.tr('HOME_QUICK_VETO_SUBLINE_2'));
				this.sensor = zone.getSensor('temperature', 'room_temperature_nominal_quick');
				this.dashIcon = '';
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);

				return;
			}
			case 'heating_off': {
				this.disableSlider();
				this.mode = 'heating_off';
				this.text = new Array<string>();
				this.text.push(this.translator.tr('DELIGHT_DASHBOARD_HEATING_SWITCHED_OFF'));
				let secondLine = this.translator.tr('HOME_HEATING_SUBLINE_2') + " ";
				secondLine += this.ioService.deviceInfo().getDefaultZone().getSensor('temperature', 'room_temperature').toString();
				this.text.push(secondLine);
				this.dashIcon = ('iconHeatingDis');
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);

				return;
			}
			case 'absent': {
				this.disableSlider();
				this.menuService.disableButton('question');
				this.menuService.disableButton('menu');
				this.mode = 'absent';
				this.text = new Array<string>();
				this.dashIcon = 'iconAway';
				this.text.push(this.translator.tr('HOME_HOLIDAY_SUBLINE_1'));

				let absenceEnd = this.ioService.deviceInfo().getDefaultZone().getDate('absenceEnd');
				let endString = "";
				endString += Helper.twoDigits(absenceEnd.getDate()) + "." + Helper.twoDigits(absenceEnd.getMonth() + 1) + "." + Helper.twoDigits(absenceEnd.getFullYear() - 2000);
				endString += " / " + Helper.formatTime(absenceEnd);
				this.text.push(endString);
				this.text.push(this.translator.tr('HOME_HOLIDAY_SUBLINE_3'));
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				return;
			}
			default: {
				this.mode = "default";

				this.sensor = this.ioService.getCurrentNominalTemperatureSensor();
				if (this.noHeatingDemand()) {
					this.dashIcon = 'iconInformation';
					this.text = new Array<string>();
					this.text.push(this.translator.tr('DELIGHT_DASHBOARD_NO_HEAT_DEMAND'));
				}
				this.debugOut("OnInit");
				this.eventSubscription = this.ioService.inputs.events$.subscribe(
					(event) => { this.eventHandler(event); }
				);
				this.menuService.resetMenuPositions();
			}
		}

	}
	noHeatingDemand() {
		return ((this.sensor == null || this.sensor == undefined) && this.mode == "default");
	}
	getText(idx: number): string {
		//console.log("asked for text id " + idx + " while mode is " + this.mode);
		switch (this.mode) {
			case 'heating':
			case 'dhw':
			case 'heating_off':
			case 'absent':
			case 'system_off':
			case 'ventilation_boost':
			case 'continuous_cooling':
			case 'cylinder_boost':
			case 'quickset-temperature':
			case 'remote-controlled':
			case 'estrichttrocknung': {
				if (this.text && this.text.length > idx) {
					return this.text[idx];
				} else {
					return "";
				}
			}
			default: {
				if (this.noHeatingDemand() && idx == 0) {
					return this.text[0];
				}
				return this.menuService.getCurrentNode().getText(idx);
			}
		}
	}

	get value() {
		return this.sensor.toString({ include_unit: false });
	}
	ngOnDestroy() {
		this.debugOut("onDestroy");
		if (this.eventSubscription) {
			this.eventSubscription.unsubscribe();
		}
	}

	debugOut(msg: string): void {
		if (this.debug) {
			console.log("DashboardComponent: " + msg);
		}
	}
	eventHandler(event) {
		this.debugOut("Handling Event: " + event);
		console.log("Event in dashboard:" + event);
		switch (event) {
			case 'dhw': {
				if (this.mode != 'dhw') {
					console.log("reinit -> dhw (" + this.getMode() + ")");
					this.ngOnInit();
				}
				return;

			}

			case 'heating': {
				if (this.mode != 'heating') {
					console.log("reinit -> heating (" + this.getMode() + ")");
					this.ngOnInit();
				}
				return;

			}
			case 'down':
			case 'panup':
			case 'pandown':
			case 'up': {
				if (this.mode == 'dhw') {
					this.menuService.goto('quickset-desired-dhw');
					return;
				}
				if (this.mode == 'heating') {
					if (this.ioService.getConfiguration().simulatorConfig.hasSensoDIRECT()) {
						//this.menuService.goto('quickset-desired-flowtemp-sensodirect');
						this.menuService.goto('desired-temperature');
						//this.menuService.goto('quickset-desired-temperature');

					} else {
						this.menuService.goto('quickset-desired-flowtemp');
					}
					return;
				}
				let heatingMode = this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode');
				switch (heatingMode) {
					case 'ENUM_HEATING_MODE_OFF': {
						return;
					}
					case 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_MANUAL': {
						this.menuService.goto('desired-temperature');
						return;
					}
					case 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_AUTO': {
						this.menuService.goto('quickset-desired-temperature');
						return;
					}

				}

				break;
			}
			case 'confirm': {
				break;
			}
			case 'menu': {

				if (this.ioService.deviceInfo().getValue('system_off') == 'off') {
					this.menuService.goto('mainmenu');
				}
				break;
			}
			case 'back': {
				let backTarget = 'dashboard';
				let retVal: ValueChangedConfirmation = undefined;
				switch (this.mode) {

					case 'system_off':
					case 'ventilation_boost':
					case 'cylinder_boost': {
						let confirmation = new ValueChangedConfirmation(this.mode, 'on', 'off', new MenuNode({ 'target': 'goto:' + backTarget }));
						this.ioService.deviceInfo().setValue(this.mode, 'off');
						this.menuService.goto(backTarget, confirmation);
						return;
					}
					case 'continuous_cooling': {
						let confirmation = new ValueChangedConfirmation(this.mode, 'on', 'off', new MenuNode({ 'target': 'goto:' + backTarget }));
						this.ioService.deviceInfo().setValue(this.mode, 'off');
						this.menuService.goto(backTarget, confirmation);
						return;
					}
					case 'quickset-temperature': {
						let zone = this.ioService.deviceInfo().getDefaultZone();
						zone.getScale('quickset-temperature-duration').setCurrentValue(3, true);
						zone.setValue('quickset-temperature-enabled', 'off');
						retVal = new ValueChangedConfirmation('quickset-temperature-enabled', 'on', 'off', new MenuNode({ 'target': 'goto:' + backTarget }));
						this.menuService.goto(backTarget, retVal);
						return;
					}
					case 'estrichttrocknung': {
						let oldVal = -1;
						for (let hc of this.ioService.deviceInfo().getHeatingCircuits()) {
							oldVal = hc.getScale('estrichtTrocknungsTag').getCurrentValue();
							hc.getScale('estrichtTrocknungsTag').setCurrentValue(0);

						}

						retVal = new ValueChangedConfirmation('estrichtTrocknungsTag', 'on', 'off', new MenuNode({ 'target': 'goto:' + backTarget }));
						this.menuService.goto(backTarget, retVal);
						return;

					}
					case 'absent': {
						let zone = this.ioService.deviceInfo().getDefaultZone();
						let startDate = zone.getDate('absenceBegin');
						zone.setDate('absenceEnd', startDate);
						retVal = new ValueChangedConfirmation('absenceEnd', 'on', 'off', new MenuNode({ 'target': 'goto:' + backTarget }));
						this.menuService.goto(backTarget, retVal);
						return;
					}
					default: {
						this.menuService.goto('idle');
					}
				}

				break;
			}
			case 'question': {
				if (!['absent', 'system_off'].includes(this.mode)) {
					let benutzerHandbuch = this.menuService.findItem('benutzerhandbuch');
					if (benutzerHandbuch) {
						this.menuService.goto(benutzerHandbuch);
					}
					return;
				} else {
					this.debugOut("Doing nothing: mode is " + this.mode);
				}
			}
			default: {

			}
		}
	}

}
